import { ProductLine } from 'apis/restaurant-api/merchant-admin/venue/types';
import { ItemDiscountType } from 'modules/campaigns/types';

type VariantConfig = {
  isAllDiscountTypeEnabled: boolean;
  config?: Record<ItemDiscountType, ProductLine[]>;
};

const ALL_PRODUCT_LINES: ProductLine[] = [
  'restaurant',
  'grocery',
  'general_merchandise',
  'pharmacy',
  'gift_card',
  'cosmetics',
  'health_and_beauty',
  'pet_supply',
  'charity',
  'florist',
  'bookstore',
  'subscription',
  'other',
  'alcohol',
];

const configGroceryForAll: VariantConfig = {
  isAllDiscountTypeEnabled: false,
  config: {
    [ItemDiscountType.X_FOR_FREE]: ALL_PRODUCT_LINES,
    [ItemDiscountType.PERCENTAGE_OFF]: ['grocery'],
    [ItemDiscountType.AMOUNT_OFF]: ['grocery'],
  },
};

const configRestaurantForAll: VariantConfig = {
  isAllDiscountTypeEnabled: false,
  config: {
    [ItemDiscountType.X_FOR_FREE]: ALL_PRODUCT_LINES,
    [ItemDiscountType.PERCENTAGE_OFF]: ['grocery'],
    [ItemDiscountType.AMOUNT_OFF]: ['grocery'],
  },
};

const configGroceryAndRestaurantForAll: VariantConfig = {
  isAllDiscountTypeEnabled: false,
  config: {
    [ItemDiscountType.X_FOR_FREE]: ALL_PRODUCT_LINES,
    [ItemDiscountType.PERCENTAGE_OFF]: ['grocery', 'restaurant'],
    [ItemDiscountType.AMOUNT_OFF]: ['grocery', 'restaurant'],
  },
};

const configOnlyEnabledXForFree: VariantConfig = {
  isAllDiscountTypeEnabled: false,
  config: {
    [ItemDiscountType.X_FOR_FREE]: ALL_PRODUCT_LINES,
    [ItemDiscountType.PERCENTAGE_OFF]: [],
    [ItemDiscountType.AMOUNT_OFF]: [],
  },
};

const configEverythingEnabled: VariantConfig = {
  isAllDiscountTypeEnabled: true,
};

export const countryConfig: Record<Country, VariantConfig> = {
  ALB: configEverythingEnabled,
  AZE: configEverythingEnabled,
  AUT: configOnlyEnabledXForFree,
  CYP: configGroceryForAll,
  HRV: configOnlyEnabledXForFree,
  CZE: configGroceryAndRestaurantForAll,
  DNK: configRestaurantForAll,
  EST: configGroceryForAll,
  FIN: configGroceryAndRestaurantForAll,
  GEO: configEverythingEnabled,
  DEU: configOnlyEnabledXForFree,
  GRC: configOnlyEnabledXForFree,
  HUN: configGroceryAndRestaurantForAll,
  ISL: configOnlyEnabledXForFree,
  ISR: configEverythingEnabled,
  JPN: configEverythingEnabled,
  KAZ: configEverythingEnabled,
  LUX: configOnlyEnabledXForFree,
  LVA: configGroceryAndRestaurantForAll,
  LTU: configGroceryForAll,
  MLT: configGroceryAndRestaurantForAll,
  NOR: configEverythingEnabled,
  POL: configGroceryForAll,
  SRB: configEverythingEnabled,
  SVK: configGroceryAndRestaurantForAll,
  SVN: configGroceryAndRestaurantForAll,
  SWE: configGroceryForAll,
  UZB: configOnlyEnabledXForFree,
};
